var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"utlz-shopping-cart-control"},[_c('ul',_vm._l((_vm.shoppingCart),function(row){return _c('li',{key:row.id},[_c('h5',[_vm._v(_vm._s(row.id))])])}),0),_c('span',[_vm._v(_vm._s(_vm.totalPrice))])])}
var staticRenderFns = []

export { render, staticRenderFns }